import React from 'react';

export const defaultState = {
    users: [],
    fetchUsers: () => { },
};
const UsersContext = React.createContext(defaultState);
export const UsersConsumer = UsersContext.Consumer;
export default UsersContext;
